import { ONLY_ALPHANUMERICS_WITH_SPACE } from './regex'

export const clsAlphaNoOnly = (e: any) => {
  const str = String.fromCharCode(!e.charCode ? e.which : e.charCode)

  e.preventDefault()

  return ONLY_ALPHANUMERICS_WITH_SPACE.test(str)
}
